import { useEffect, useState } from "preact/hooks"
import { modalColor } from "src/161759/utils"
import { Modal, ModalWrapper } from "src/utils/fw"

export const dismiss = {
    dismissHTML:"X",
    dismissStyle:{
        padding: "0",
        color: "white", 
        fontSize: "18px", 
        top: "9px", 
        right: "13px", 
        width: "21px",
        height: "23px",
        textAlign: "center"
    },
}

export default ({open = false, onChange = () => {}}) => {

    const [op, setOpen] = useState(open)



    useEffect(() => {
        if (open !== op) setOpen(open)
    }, [open])

    useEffect(() => {
        if (open !== op) onChange(op)
    }, [op])

    if (!op) return <></>

    return <Modal {...dismiss} dismiss={() => {
        setOpen(false)
        }} style={{width: "30%", minWidth: "763px", color: "white"}} >
        <ModalWrapper
            onClose={setOpen} 
            open={op}
            wrapperStyle={{background: modalColor}}>
            <h3 style={{fontSize: "1.5em", textAlign: "center"}}>Explore the platform for your chance to win! Participate in activities across the platform to gain points. Top scorers will win prizes.</h3>

            <p>If you have not opted-in to the Attendee Directory, you cannot take part in the leaderboard or receive any points.<br/>
            To opt-in, please modify your registration here and opt-in to the Attendee Directory.</p>
            <p><a href="https://isfcongress.tkeventsregistration.com/2024/begin" style={{
                float: "none"
            }}>Update your registration</a></p>

            <p>All winners will be contacted after the event.</p>

            <h3 style={{fontSize: "1.5em"}}>HOW TO EARN POINTS</h3>
            <ul style={{fontSize: "1.3em"}}>
                <li>View keynote presentation - <b>75 points</b></li>
                <li>View breakout presentation - <b>50 points</b></li>
                <li>View on-demand presentation - <b>50 points</b></li>
                <li>Provide session feedback - 20 points
                    <b style={{display: "block", fontSize: ".7em", marginLeft: "5px", marginBottom: "5px"}}>Please provide feedback immediately following each session to receive your points</b>
                </li>
                <li>Watch exhibition stand video - <b>40 points</b></li>
                <li>Download exhibition stand brochure - <b>20 points</b></li>
                <li>Contact a sponsor from their stand - <b>20 points</b></li>
                <li>Watch ISF video in Exploration Zone - <b>40 points per day, per video</b></li>
                <li>Listen to ISF podcast in Exploration Zone - <b>40 points per day</b></li>
                <li>Download content from Exploration Zone - <b>20 points per day</b></li>
            </ul>
        </ModalWrapper>
    </Modal>
}